var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionListFlat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H22V6H6V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H4V6H2V4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9H6V11H22V9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H4V11H2V9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H6V16H22V14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H4V16H2V14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19H6V21H22V19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19H4V21H2V19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionListFlat);
export default __webpack_public_path__ + "static/media/ic_action_list_flat.34b804de48c8653e47cf4d01887093ea.svg";
export { ForwardRef as ReactComponent };